/**
 * Application-wide constants
 * Centralized location for magic numbers and strings
 */

export const DELAYS = {
  SHORT: 1000,
  MEDIUM: 3000,
  LONG: 5000,
  TOAST_AUTO_CLOSE: 3000,
} as const;

export const CACHE_TIMES = {
  ONE_MINUTE: 60 * 1000,
  FIVE_MINUTES: 5 * 60 * 1000,
  TEN_MINUTES: 10 * 60 * 1000,
  THIRTY_MINUTES: 30 * 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
} as const;

export const ROLES = {
  BUSINESS_OWNER: 'BusinessOwner',
  ADMIN: 'Admin',
  STAFF: 'Staff',
  CAPTAIN: 'Captain',
  WAITER: 'Waiter',
  USER: 'user',
  OWNER: 'owner',
} as const;

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  AUTH_TOKEN: 'authToken',
  CAPTAIN_TOKEN: 'captainToken',
  LOYALTY_AUTH_TOKEN: 'loyaltyAuthToken',
  USER_EMAIL: 'userEmail',
  USER_PHONE: 'userPhone',
  USER_NAME: 'userName',
  USER_FIRST_NAME: 'userFirstName',
  USER_LAST_NAME: 'userLastName',
  USER_FULL_NAME: 'userFullName',
  USER_ID: 'userId',
  BUSINESS_ID: 'businessId',
  RESTAURANT_ID: 'restaurantId',
  BUSINESS_NAME: 'business_name',
  RESTAURANT_NAME: 'restaurant_name',
  ROLE: 'role',
  USER_ROLES: 'userRoles',
  PLAN: 'plan',
  PLAN_STATUS: 'plan_status',
  PLAN_ID: 'planId',
  PLAN_PRICE: 'planPrice',
  HAS_ACTIVE_SUBSCRIPTION: 'hasActiveSubscription',
  DAYS_REMAINING: 'daysRemaining',
  SUBSCRIPTION_STATUS: 'subscriptionStatus',
  PERMISSIONS: 'permissions',
  AVAILABLE_FEATURES: 'availableFeatures',
  CUSTOMER_TOKEN: 'customerToken',
  CUSTOMER_ID: 'customerId',
  CAPTAIN_USER: 'captainUser',
  PWA_INSTALL_DISMISSED: 'pwa-install-dismissed',
  MANUAL_LOGOUT: 'manual_logout',
  PENDING_PHONEPE_TRANSACTION: 'pendingPhonePeTransactionId',
  INCLUDED_MODULES: 'includedModules',
  USER: 'user',
  USER_TYPE: 'userType',
  LAST_VISITED_PATH: 'lastVisitedPath',
  FORCE_LOGIN_PAGE: 'forceLoginPage',
  AUTH_DATA_TIMESTAMP: 'authDataTimestamp',
  LOGO_URL: 'logoUrl',
  LOYALTY_RESTAURANT_ID: 'loyaltyRestaurantId',
  REFRESH_TOKEN: 'refreshToken',
  USER_ROLE: 'userRole',
} as const;

export const SESSION_STORAGE_KEYS = {
  MANUAL_LOGOUT: 'manual_logout',
  SW_LAST_RELOAD: 'sw-last-reload',
  SW_RELOADED: 'sw-reloaded',
} as const;

export const API_TIMEOUTS = {
  DEFAULT: 30000, // 30 seconds
  LONG: 60000, // 1 minute
  SHORT: 10000, // 10 seconds
} as const;

export const RETRY_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
  RETRY_STATUS_CODES: [500, 502, 503, 504],
} as const;

export const IMAGE_CONFIG = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
  COMPRESSION_OPTIONS: {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  },
} as const;

export const PASSWORD_VALIDATION = {
  MIN_LENGTH: 8,
  REQUIRE_UPPERCASE: true,
  REQUIRE_LOWERCASE: true,
  REQUIRE_NUMBER: true,
  REQUIRE_SPECIAL: true,
} as const;

export const POPUP_CONFIG = {
  PAYMENT: {
    WIDTH: 500,
    HEIGHT: 700,
  },
  QR_PRINT: {
    WIDTH: 800,
    HEIGHT: 600,
  },
} as const;

export const DEBOUNCE_DELAYS = {
  SEARCH: 300,
  INPUT: 500,
  RESIZE: 200,
  SCROLL: 150,
} as const;
